import { numberComparator } from '../shared/utils/utils';

import { convertToCents } from '../../shared/utils/utils';

export const getRowId = (params: any) => {
    return params?.data?.quoteId;
};

export const getGrandTotalComparator = (valueA: string, valueB: string) => {
    const valA = convertToCents(Number(valueA.split('$')[1].replace(',', '')));
    const valB = convertToCents(Number(valueB.split('$')[1].replace(',', '')));

    return numberComparator(valA, valB);
};
